function Products(props) {
  const user = props.user;
  return (
    <div>
      <h1>Welcome {user.LongName}!</h1>
      <h2> You are at products page page.</h2>
    </div>
  );
}

export default Products;
